export class ApiError extends Error {
	constructor(
		message: string,
		public responseBody: any
	) {
		super(message);
		this.name = 'ApiError';
	}
}

export type ServerError = {
	key: string;
	attribute: string;
};
